import AdminLayout from 'layouts/Admin/Admin.jsx';
import GuestLayout from 'layouts/Guest/Guest.jsx';
import RTLLayout from 'layouts/RTL/RTL.jsx';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Switch, Redirect } from 'react-router-dom';

import history from './history';

import 'assets/scss/black-dashboard-react.scss';
{
  /* The following line includes the custom styles */
}
import 'assets/demo/demo.css';
import 'assets/css/nucleo-icons.css';
import 'assets/scss/login.scss';
import 'react-datepicker/dist/react-datepicker.min.css';
import 'assets/scss/react-datepicker.scss';
import 'assets/scss/custom-styles.scss';

ReactDOM.render(
  <Router history={history}>
    <Switch>
      <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
      <Route path="/geek" render={(props) => <AdminLayout {...props} />} />
      <Route path="/guest" render={(props) => <GuestLayout {...props} />} />
      <Route path="/client" render={(props) => <GuestLayout {...props} />} />
      <Route path="/app" render={(props) => <GuestLayout {...props} />} />
      <Route path="/login" render={(props) => <RTLLayout {...props} />} />
      <Route
        path="/forgot-password"
        render={(props) => <RTLLayout {...props} />}
      />

      <Route path="/change-mfa" render={(props) => <RTLLayout {...props} />} />
      <Route
        path="/change-password"
        render={(props) => <RTLLayout {...props} />}
      />
      <Route
        path="/account-confirmation"
        render={(props) => <RTLLayout {...props} />}
      />
      <Route
        path="/privacy-policy"
        render={(props) => <RTLLayout {...props} />}
      />
      <Route path="/maintenance" render={(props) => <RTLLayout {...props} />} />
      <Redirect from="/" to="/login" />
    </Switch>
  </Router>,
  document.getElementById('root'),
);
